import React from 'react';
import { Radio } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';

import { useToggleableRadio } from '@/components/views/Report/KimLhc/hooks';
import { WORK_CONDITION_OPTIONS } from '@/components/views/Report/KimLhc/Constants';

import * as S from './styles';

interface AdverseConditionsFormItemProps {
	fieldName: NamePath;
}

export function AdverseConditionsFormItem({ fieldName }: Readonly<AdverseConditionsFormItemProps>): JSX.Element {
	const handleRadioClick = useToggleableRadio(fieldName);

	return (
		<S.FormItemRow name={fieldName}>
			<Radio.Group>
				<S.RadioOptionsContainer>
					{WORK_CONDITION_OPTIONS.adverse_conditions.map((option) => (
						<Radio key={option.value} value={option.value} onClick={() => handleRadioClick(option.value)}>
							{I18n.get(option.labelKey)}
						</Radio>
					))}
				</S.RadioOptionsContainer>
			</Radio.Group>
		</S.FormItemRow>
	);
}
